/**
 * Search filters reducer
 * @module src/reducers/bimFooter
 */

import { GET_BIM_FOOTER } from '@package/actions';

const initialState = {
  error: null,
  hasError: false,
  result: {},
  loadingResults: false,
};

export const bimFooterReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case `${GET_BIM_FOOTER}_PENDING`:
      return {
        ...state,
        loadingResults: true,
      };

    case `${GET_BIM_FOOTER}_SUCCESS`:
      return {
        ...state,
        result: action.result,
        loadingResults: false,
      };

    case `${GET_BIM_FOOTER}_FAIL`:
      return {
        ...state,
        error: action.error,
        hasError: true,
        loadingResults: false,
      };

    default:
      return state;
  }
};
